import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { setSidebarCollapsed } from "../store/uiSlice";

const DashboardLayout = () => {
  const isCollapsed = useSelector((state) => state.ui.isSidebarCollapsed);
  const dispatch = useDispatch();
  
  const sidebarWidth = isCollapsed ? "w-auto" : "w-[18%]";
  const mainContentWidth = isCollapsed ? "w-full" : "w-[80%]";

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1025) {
        dispatch(setSidebarCollapsed(true));
      }
    };

    // Set initial state on mount
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  return (
    <div className="min-h-screen bg-gradient-to-tr from-white to-[#d9ebff] text-[#0a2540] flex flex-col">
      {/* Full-width Header */}
      <header className="h-16 w-full z-10 mb-4">
        <Header />
      </header>

      {/* Main content area with sidebar + page */}
      <div className="flex flex-1 min-h-0">
        {/* Sidebar */}
        <aside className={`h-full ${sidebarWidth} shrink-0`}>
          <Sidebar />
        </aside>

        {/* Page content */}
        <main className={`flex-1 overflow-y-auto pr-4 ${mainContentWidth} mb-8`}>
          <Outlet />
        </main>
      </div>

      {/* Full-width Footer */}
      <footer
        className="h-14 w-full border-t border-white/20 bg-white/30 backdrop-blur-lg z-10"
        style={{ zIndex: 1 }}
      >
        <Footer />
      </footer>

      {/* Scroll to top button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-6 right-6 z-20 p-3 rounded-full shadow-lg text-white bg-gradient-to-tr from-[#1a325d] to-[#27ade3] hover:scale-105 transition-transform"
        aria-label="Scroll to top"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 15l7-7 7 7"
          />
        </svg>
      </button>
    </div>
  );
};

export default DashboardLayout;